<template>
    <section class="selected-item-wrapper">
        <header class="section-header">
            <h2 class="section-title">{{ selectedItem.name }}</h2>
            <button class="button primary hollow close" @click="closeSelectedItem">X</button>
        </header>
        <div class="section-body">
            {{ selectedItem.address }}<br>
            {{ selectedItem.city }}<br>
            {{ selectedItem.state }}<br>
            {{ selectedItem.postal_code }}<br>
            {{ selectedItem.hours }}<br>
            {{ selectedItem.phone }}<br>
            {{ selectedItem.fax }}<br>
            {{ selectedItem.email }}<br>
            {{ selectedItem.contact_person }}<br>
            {{ selectedItem.services }}<br>
            {{ selectedItem.resource_url }}<br>
            {{ selectedItem.tutor_address }}<br>
            {{ selectedItem.mailing_address }}<br>
            {{ selectedItem.programming_note }}<br>
            {{ selectedItem.biographical_note }}<br>
            {{ selectedItem.other_information_note }}<br>
            {{ selectedItem.subjects }}<br>
        </div>
    </section>
</template>

<script>


export default {

    props: {
        selectedItem: {
            type:    Object,
            default: {}
        },
    },

    data() {
        return {};
    },
    mounted() {

    },
    computed: {},
    methods:  {
        closeSelectedItem() {
            this.$parent.selectedItem = {};
        }
    }
}
</script>
